import { Card, CardContent } from '../ui/card';
import { Eye } from 'lucide-react';

/**
 * View only notice for restricted admin users
 */
export const ViewOnlyNotice = () => {
  return (
    <Card className="mt-6 bg-blue-50 border-blue-200">
      <CardContent className="p-4">
        <div className="flex items-center gap-3">
          <Eye className="w-6 h-6 text-blue-600" />
          <div>
            <p className="font-medium text-blue-700">View Only Access</p>
            <p className="text-sm text-blue-600/80">
              You can view data and download reports, but cannot make changes.
            </p>
          </div>
        </div>
      </CardContent>
    </Card>
  );
};

export default ViewOnlyNotice;
